exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "app-set-actual-yield .mat-dialog-title {\n  text-transform: none !important; }\n", ""]);

// exports
